import { SelectField } from 'components/ui_library/Formik';
import { EntityType } from 'modules/Compute/Components/ComputeEntitySelector/useGenerateOptions';
import { FieldValidator } from 'formik';
import { menuWrapperStyles } from 'modules/Compute/Components/ComputeEntitySelector/ComputeEntitySelector.styled';
import { SelectOption } from 'components/ui_library/Formik/components/FormElements/Select';
type ComputeSelectorProps = {
  'data-testid'?: string;
  className?: string;
  entityType: EntityType;
  isDisabled?: boolean;
  name: string;
  onSelect?: (value: string, option: Record<string, unknown>) => void;
  options: SelectOption[];
  placeholder?: string;
  validate?: FieldValidator;
};

/**
 * This will be used to select the compute cluster, nodepools and deployments
 *
 * You can either access a selected option by using the onSelect callback or by accessing the formik values.
 * The 'name' prop is used to set the key in the formik values.
 *
 * OPTIONAL:
 * If you require the selected entity data in the formik values, you can access it by setting the
 * key 'nodepoolData', 'clusterData' or 'deploymentData' in the formik values. If the parent form component
 * does not have these keys, the selected entity data will not be set in the formik values.
 *
 */
export const ComputeEntitySelector = (props: ComputeSelectorProps) => {
  const {
    'data-testid': dataTestId,
    className,
    entityType,
    isDisabled,
    name,
    onSelect,
    options,
    placeholder,
    validate
  } = props;
  if (!options) return null;

  // Set the initial deployment to the first available, or Clarifai Shared
  let initialValue;
  if (entityType === 'deployment') initialValue = options.length > 2 ? options[1]?.value : options[0]?.value;
  return <SelectField className={className} data-testid={dataTestId} disabled={isDisabled} initialValue={initialValue} menuWrapperClass={menuWrapperStyles} name={name} onChange={option => onSelect?.(option?.value, option)} options={options} placeholder={placeholder || `Select a ${entityType}`} validate={validate} />;
};